import { render, staticRenderFns } from "./manage-trainings.vue?vue&type=template&id=4b4c077b&"
import script from "./manage-trainings.vue?vue&type=script&lang=js&"
export * from "./manage-trainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports